import { render, staticRenderFns } from "./CreateSoloMarket.vue?vue&type=template&id=e236fecc"
import script from "./CreateSoloMarket.vue?vue&type=script&lang=js"
export * from "./CreateSoloMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports